import React, { useEffect, useState } from 'react'
import { useField } from 'formik'
import { FiEye, FiEyeOff } from 'react-icons/fi'

import {
    InputContainer, Textbox
} from './styles'

function PasswordTextbox({ name, label, disableSubmitWithEnter = true, onChange, containerClass = '', className = '' }) {
	const [field, meta, helpers] = useField(name)
	const [maskedPassword, setMaskedPassword] = useState('')
	const [showRealPassword, setShowRealPassword] = useState(false)

	function handleChange(e) {
		const input = e.target.value
		const realPassword = field.value || ''

		let newRealPassword = realPassword
		const newChar = input.at(-1) || ''

		if (input.length > maskedPassword.length) {
			newRealPassword = realPassword + newChar
		} else {
			newRealPassword = realPassword.slice(0, input.length)
		}

		setMaskedPassword('*'.repeat(newRealPassword.length))

		helpers.setValue(newRealPassword)

		onChange?.(newRealPassword)
	}

	const Icon = showRealPassword ? FiEyeOff : FiEye

	return (
		<InputContainer className={containerClass}>
			<span className="label">{label}</span>

			<Textbox
				{...field}
				id={name}
				type="text"
				value={showRealPassword ? field.value : maskedPassword}
				onChange={handleChange}
				className={className}
				onKeyPress={e => {
					if (disableSubmitWithEnter && e.key === 'Enter') {
						e.preventDefault()
					}
				}}
			/>

			<Icon 
				size={40} 
				onClick={() => { setShowRealPassword(old => !old) }} 
			/>

			{meta.touched && meta.error
                ? (
                    <span className="error mt-1">
                        {meta.error}
                    </span>
                )
                : null}
		</InputContainer>
	)
}

export default PasswordTextbox
